import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-component-name"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", {
    "data-component-name": _ctx.$options.name,
    class: _normalizeClass(["o-grid o-grid-12 o-form__section", {
            'step-section': $props.section.isStep,
            'prev-section': $props.section.isStep && $props.section.stepIndex < $props.currentStep,
            'next-section': $props.section.isStep && $props.section.stepIndex > $props.currentStep,
            'current-section': $props.section.isStep && $props.section.stepIndex == $props.currentStep,
            'hidden-fields-section': $options.isHiddenFieldsSection,
        }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.section.fields, (field, fi) => {
      return (_openBlock(), _createBlock(_resolveDynamicComponent(field.type), {
        key: field.id,
        field: field,
        disabledIDs: $props.disabledIDs,
        sectionTitle: (fi==0)? $props.section.title : null
      }, null, 8 /* PROPS */, ["field", "disabledIDs", "sectionTitle"]))
    }), 128 /* KEYED_FRAGMENT */))
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}